/* eslint-disable no-restricted-imports -- the wrapper module is the moment island during the shadow window; raw moment access is required to delegate the Moment side of the comparison. */
import moment, {
  type Duration,
  type DurationInputArg1,
  type DurationInputArg2,
} from 'moment';

import { dayjsApi, durationSerializer, runShadow } from './shadow-runner';
import type { DomainNameType } from './subdomains';

type TagShapeType = { domain: DomainNameType; subdomain: string };

type ShadowDurationType = (
  input?: DurationInputArg1,
  unit?: DurationInputArg2
) => Duration;

// The dayjs duration plugin types its factory as an intersection of three
// overloads, which TypeScript cannot pick from a generic forwarded call. The
// shadow wrapper unifies the surface to a single `(input, unit) => Duration`
// shape that matches what every moment caller actually passes.
type AnyDurationFactoryType = (input?: unknown, unit?: unknown) => unknown;

export function shadowDuration(tags: TagShapeType): ShadowDurationType {
  return (input, unit) => {
    return runShadow({
      op: 'duration',
      ...tags,
      inputs: [input, unit],
      computeMoment: () => moment.duration(input, unit),
      computeDayjs: () =>
        (dayjsApi.datetime.duration as AnyDurationFactoryType)(input, unit) as {
          humanize: (withSuffix?: boolean) => string;
        },
      serialize: durationSerializer,
    });
  };
}
